import { useEffect, useState } from "react";

export default function useUserRoles(currentUser) {
  const [isAStudent, setIsAStudent] = useState(undefined);
  const [isATeacher, setIsATeacher] = useState(undefined);
  const [isAnAdmin, setIsAnAdmin] = useState(undefined);
  const [isAReferenceStudent, setIsAReferenceStudent] = useState(undefined);

  useEffect(() => {
    if (currentUser?.roles) {
      setIsAStudent(currentUser.roles.includes("Student"));
      setIsATeacher(currentUser.roles.includes("Teacher"));
      setIsAnAdmin(currentUser.roles.includes("Admin"));
      setIsAReferenceStudent(currentUser.roles.includes("ReferenceStudent"));
    }
  }, [currentUser]);

  return {
    isAStudent,
    isATeacher,
    isAnAdmin,
    isAReferenceStudent,
  };
}
